<script>
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
dayjs.extend(utc)

export default {
    name: 'MachineDetailsComponent',

    props: {
        machine: {
            type: Array,
            requiered: true
        },
        languageStrings: {
            type: Object,
            default: null
        },
        role: {
            type: Number,
            default: 0
        },
        isLinde: {
            type: Boolean,
            default: false
        },
        localLanguages: {
            type: Object,
            default: null
        }
    },
    
    methods: {
        formatDate(date) {
            return date !== null ? dayjs(date + 'Z').utcOffset(0).format('D.M.YYYY') : ''
        }
    }
}
</script>


<template>
    <table v-if="machine.length > 0">				
        <tbody>
            <tr>
                <th>{{ languageStrings != null && languageStrings.ui != null && languageStrings.ui.machine001 != null ? languageStrings.ui.machine001 : 'Název' }}</th>
                <td>{{ machine[0].name != null ? machine[0].name : '' }}</td>
            </tr>
            <tr>
                <th>{{ languageStrings != null && languageStrings.ui != null && languageStrings.ui.machine002 != null ? languageStrings.ui.machine002 : 'Složka' }}</th>
                <td>{{ machine[0].folder != null ? machine[0].folder.name : '' }}</td>
            </tr>
            <tr>
                <th>{{ languageStrings != null && languageStrings.ui != null && languageStrings.ui.machine003 != null ? languageStrings.ui.machine003 : 'ID stroje' }}</th>
                <td>{{ machine[0].customerId != null ? machine[0].customerId : '' }}</td>
            </tr>
            <tr>
                <th>{{ languageStrings != null && languageStrings.ui != null && languageStrings.ui.machine004 != null ? languageStrings.ui.machine004 : 'Výrobce' }}</th>
                <td>{{ machine[0].producer != null ? machine[0].producer : '' }}</td>
            </tr>
            <tr>
                <th>{{ languageStrings != null && languageStrings.ui != null && languageStrings.ui.machine005 != null ? languageStrings.ui.machine005 : 'Typ stroje' }}</th>
                <!-- <td>{{ machine[0].type != null ? machine[0].type : '' }}</td> -->
                <td>{{ machine[0].type != null ? localLanguages.machineTypes.find(mt => mt.id === machine[0].type) != null ? localLanguages.machineTypes.find(mt => mt.id === machine[0].type).name : '' : '' }}</td>
            </tr>
            <tr>
                <th>{{ languageStrings != null && languageStrings.ui != null && languageStrings.ui.machine006 != null ? languageStrings.ui.machine006 : 'Model' }}</th>
                <td>{{ machine[0].model != null ? machine[0].model : '' }}</td>
            </tr>
            <tr>
                <th>{{ languageStrings != null && languageStrings.ui != null && languageStrings.ui.machine007 != null ? languageStrings.ui.machine007 : 'Rok výroby' }}</th>
                <td>{{ machine[0].yearProduced != null ? machine[0].yearProduced : '' }}</td>
            </tr>
            <tr>
                <th>{{ languageStrings != null && languageStrings.ui != null && languageStrings.ui.machine008 != null ? languageStrings.ui.machine008 : 'Objem oleje (l / kg)' }}</th>
                <td>{{ machine[0].volume != null ? machine[0].volume : '' }}</td>
            </tr>
            <tr>
                <th>{{ languageStrings != null && languageStrings.ui != null && languageStrings.ui.machine009 != null ? languageStrings.ui.machine009 : 'Výrobce oleje' }}</th>
                <td>{{ machine[0].oilProducer != null ? machine[0].oilProducer : '' }}</td>
            </tr>
            <tr>
                <th>{{ languageStrings != null && languageStrings.ui != null && languageStrings.ui.machine010 != null ? languageStrings.ui.machine010 : 'Značka oleje' }}</th>
                <td>{{ machine[0].oilBrand != null ? machine[0].oilBrand : '' }}</td>
            </tr>
            <tr>
                <th>{{ languageStrings != null && languageStrings.ui != null && languageStrings.ui.machine011 != null ? languageStrings.ui.machine011 : 'Typ oleje' }}</th>
                <!-- <td>{{ machine[0].oilType != null ? machine[0].oilType.class : '' }}</td> -->
                <td>{{ machine[0].oilType != null ? localLanguages.oilTypes.find(ot => ot.id === machine[0].oilType.id) != null ? localLanguages.oilTypes.find(ot => ot.id === machine[0].oilType.id).name : '' : '' }}</td>
            </tr>
            <tr>
                <th>{{ languageStrings != null && languageStrings.ui != null && languageStrings.ui.machine012 != null ? languageStrings.ui.machine012 : 'VT oleje' }}</th>
                <td>{{ machine[0].machineOil != null ? machine[0].machineOil.name : '' }}</td>
            </tr>
            <tr>
                <th>{{ languageStrings != null && languageStrings.ui != null && languageStrings.ui.machine013 != null ? languageStrings.ui.machine013 : 'Posl. odběr' }}</th>
                <td>{{ machine[0].lastCollection != null ? formatDate(machine[0].lastCollection) : '' }}</td>
            </tr>
            <tr>
                <th>{{ languageStrings != null && languageStrings.ui != null && languageStrings.ui.machine014 != null ? languageStrings.ui.machine014 : 'Médium' }}</th>
                <td>{{ machine[0].medium != null ? machine[0].medium : '' }}</td>
            </tr>
            <tr>
                <th>{{ languageStrings != null && languageStrings.ui != null && languageStrings.ui.machine015 != null ? languageStrings.ui.machine015 : 'Poznámka' }}</th>
                <td>{{ machine[0].description != null ? machine[0].description : '' }}</td>
            </tr>
            <tr v-if="role > 1 && role < 5">
                <th>{{ languageStrings != null && languageStrings.ui != null && languageStrings.ui.machine018 != null ? languageStrings.ui.machine018 : 'UIN' }}</th>
                <td>{{ machine[0].uinals != null ? machine[0].uinals : '' }}</td>
            </tr>
            <tr v-if="role > 1 && role < 5 && isLinde">
                <th>{{ languageStrings != null && languageStrings.ui != null && languageStrings.ui.machine019 != null ? languageStrings.ui.machine019 : 'Tag LINDE' }}</th>
                <td>{{ machine[0].tagLinde != null ? machine[0].tagLinde : '' }}</td>
            </tr>
            <tr v-if="role > 1 && role < 5">
                <th>{{ languageStrings != null && languageStrings.ui != null && languageStrings.ui.machine020 != null ? languageStrings.ui.machine020 : 'UID' }}</th>
                <td>{{ machine[0].uid != null ? machine[0].uid : '' }}</td>
            </tr>
        </tbody>
    </table>
</template>